export const ITEM_TYPES = {
  PRODUCT: "PRODUCT",
  SERVICE: "SERVICE",
} as const;

export const itemTypesOptions = [
  { label: "Product", value: ITEM_TYPES.PRODUCT },
  { label: "Service", value: ITEM_TYPES.SERVICE },
];

export const sourceFilterOptions = [
  {
    value: "STRIPE",
    label: "Stripe",
  },
  {
    value: "MANUAL",
    label: "Manually added",
  },
];

export const typeFilterOptions = [
  {
    value: ITEM_TYPES.PRODUCT,
    label: "Product",
  },
  {
    value: ITEM_TYPES.SERVICE,
    label: "Services",
  },
];
